module.exports = __webpack_public_path__ + "static/media/youtube.4fdd8574.svg";